export default __webpack_public_path__ + "3756d859b2e9ac4451aee25b20ba1729.png";